export enum PayflowRequestVerbosityEnum {
  high = 'HIGH'
}
